import React, { useEffect, useState } from 'react'
import * as Types from '../../../types'
import {
  loadFleets,
  loadCollections,
  loadExtensions,
} from '../../../services/APIServices'

const  FleetsPanel=React.memo(({
  fleets,
  selectedFleets,
  selectedCount,
  selectedVehicles,
  selectedExtensions,
  setFleets,
  setExtensions,
  setCollections,
  setSelectedCount,
  vehicleIds,
  fleetIds,
  setVehicleId,
  setFleetId,
}: {
  fleets: Types.Fleet[]
  selectedFleets: Types.Map
  selectedCount: number
  selectedVehicles: Types.Map
  selectedExtensions: Types.Map
  setFleets
  setExtensions
  setCollections
  setSelectedCount
  vehicleIds
  fleetIds
  setVehicleId
  setFleetId
}): JSX.Element =>{
  const updateCollectionsAndExtensions = async (
    inputFleets: Types.Fleet[],
    selectedExtensions: Types.Map
  ) => {
    let count = 0
    let queryString = ''

    inputFleets.map((fleet: Types.Fleet) => {
      if (fleet.selected) {
        queryString += 'f=' + fleet.id + '&'
      }
      fleet.vehicles.map((vehicle: Types.Vehicle) => {
        if (vehicle.selected) {
          queryString += 'v=' + vehicle.id + '&'
          count++
        }
      })
    })

    setSelectedCount(count)
    if (queryString.indexOf('&') > 0) {
      queryString = queryString.substr(0, queryString.length - 1)

      const [collections, emptyExtensions] = await Promise.all([
        loadCollections(queryString),
        loadExtensions(queryString),
      ])

      const formatCollections = collections.map((collection: string) => ({
        name: collection,
      }))

      setCollections([...formatCollections])

      const combinedExtensions = emptyExtensions.map((extension: string) => {
        const selected =
          selectedExtensions === undefined
            ? false
            : selectedExtensions[extension]
        return {
          name: extension,
          selected: selected === undefined ? false : selected,
        }
      })
      setExtensions(combinedExtensions)
    } else {
      setCollections([])
      setExtensions([])
    }
  }


  useEffect(
    () => {
      const initialData = async () => {
        const loadedFleets = await loadFleets()

        if (!Array.isArray(loadedFleets)) setFleets([])
        else {
          loadedFleets.forEach((fleet: Types.Fleet) => {
            fleet.vehicles.sort((a, b) => {
              if (a.name < b.name) {
                return -1
              }
              if (a.name > b.name) {
                return 1
              }
              return 0
            })
            if (selectedFleets[fleet.name]) {
              fleet.selected = true
              fleet.vehicles.forEach((vehicle: Types.Vehicle) => {
                vehicle.selected = true
              })
            } else {
              fleet.vehicles.forEach((vehicle: Types.Vehicle) => {
                if (selectedVehicles[vehicle.name]) {
                  vehicle.selected = true
                }
              })
            }
          })

          setFleets(
            loadedFleets.filter((fleet: Types.Fleet) => {
              return fleet.deleteFlag === false
            })
          )
          updateCollectionsAndExtensions(loadedFleets, selectedExtensions)
        }
      }
        initialData()
    },
    [
      // selectedExtensions,
      // selectedFleets,
      // selectedVehicles,
      // setFleets,
      // updateCollectionsAndExtensions,
    ]
  )

  function clearFleets() {
    fleets.forEach(fleet => {
      fleet.selected = false
      fleet.vehicles.forEach((vehicle: Types.Vehicle) => {
        vehicle.selected = false
      })
    })
    setFleets([...fleets])
    updateCollectionsAndExtensions(fleets, {})
  }

  function onFleetSelected(fleet: Types.Fleet) {
    fleet.selected = !fleet.selected
    fleet.vehicles.forEach((vehicle: Types.Vehicle) => {
      vehicle.selected = fleet.selected
    })
    if (!fleet.selected) {
      if (fleetIds.indexOf(fleet.id) >= 0) {
        setFleetId(
          fleetIds.filter(function (value: number) {
            return value !== (fleet.id as unknown as number)
          })
        )
      }
    } else {
      setFleetId([...fleetIds, fleet.id])
    }
    setFleets([...fleets])
    updateCollectionsAndExtensions(fleets, {})
  }

  function onVehicleSelected(vehicle: Types.Vehicle, fleet: Types.Fleet) {
    vehicle.selected = !vehicle.selected
    if (!vehicle.selected) {
      fleet.selected = false
      if (vehicleIds.indexOf(vehicle.id) >= 0) {
        setVehicleId(
          vehicleIds.filter(function (value: number) {
            return value !== (vehicle.id as unknown as number)
          })
        )
      }
    } else {
      setVehicleId([...vehicleIds, vehicle.id])
    }

    setFleets([...fleets])
    updateCollectionsAndExtensions(fleets, {})
  }

  return (
    <>
      <div>
        <h4>
          Fleets/Vehicles
          <br />
          <small>
            {selectedCount} vehicles selected
            <a href='#' onClick={clearFleets}>
              (clear)
            </a>
          </small>
        </h4>

        <div id='fleetsVehicles' className='list-group fleets-vehicle-box'>
          {fleets.map(fleet => (
            <div key={fleet.id} className='fleet-group'>
              <button type='button' key={fleet.id} className='list-group-item'>
                <input
                  type='checkbox'
                  checked={fleet.selected}
                  id={fleet.id}
                  onClick={() => onFleetSelected(fleet)}
                />
                &nbsp;
                {fleet.name}
              </button>
              <div className='fleet-vehicles-container'>
                {fleet.vehicles.map((vehicle: Types.Vehicle) => (
                  <button
                    type='button'
                    key={vehicle.id}
                    className='fleet-vehicle'
                  >
                    <input
                      type='checkbox'
                      className='vehicle-checkbox'
                      name={fleet.name}
                      checked={vehicle.selected}
                      key={vehicle.id}
                      onClick={() => onVehicleSelected(vehicle, fleet)}
                    />
                    &nbsp;
                    {vehicle.displayName}
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  )
})

export default FleetsPanel
